import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../../config/api";
import "./LoginSignup.css";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { sendSMSOtp, verifySMSOtp, resetSMSOtpState } from "../../utils/smsOtp";

const OTPVerification = () => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isResending, setIsResending] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const email = localStorage.getItem("pendingEmail");
  const phone = localStorage.getItem("pendingPhone");
  const purpose = localStorage.getItem("pendingOtpPurpose") || "register";
  const otpMethod = localStorage.getItem("pendingOtpMethod") || "email";

  const clearPendingAuth = () => {
    localStorage.removeItem("pendingEmail");
    localStorage.removeItem("pendingPhone");
    localStorage.removeItem("pendingOtpPurpose");
    localStorage.removeItem("pendingOtpMethod");
    localStorage.removeItem("pendingRegistrationData");
    resetSMSOtpState();
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsVerifying(true);

    if (!otp || otp.trim() === "") {
      setError("Please enter the OTP");
      setIsVerifying(false);
      return;
    }

    try {
      let res;

      if (otpMethod === "sms") {
        if (!phone) {
          throw new Error("Session expired. Please start again.");
        }

        let registrationData = null;

        if (purpose === "register") {
          registrationData = JSON.parse(localStorage.getItem("pendingRegistrationData") || "null");

          if (!registrationData) {
            throw new Error("Registration details expired. Please register again.");
          }
        }

        res = await verifySMSOtp({
          phone,
          otp: otp.trim(),
          purpose,
          registrationData,
        });
      } else {
        if (!email) {
          throw new Error("Session expired. Please start again.");
        }

        res = await axios.post(
          `${API_BASE}/v1/user/verify-otp`,
          {
            email,
            otp: otp.trim(),
            purpose,
          },
          { withCredentials: true }
        );
      }

      if (res.data.success) {
        clearPendingAuth();
        await refreshUser();
        navigate("/");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "OTP verification failed");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleResendOTP = async () => {
    if (otpMethod === "sms" && !phone) {
      setError("Session expired. Please start again.");
      return;
    }

    if (otpMethod === "email" && !email) {
      setError("Session expired. Please start again.");
      return;
    }

    setIsResending(true);
    setError("");
    setMessage("");

    try {
      if (otpMethod === "sms") {
        await sendSMSOtp(phone, purpose);
        setMessage("OTP resent successfully to your phone");
      } else {
        const res = await axios.post(`${API_BASE}/v1/user/send-otp`, {
          email,
          purpose,
        });

        if (res.data.success) {
          setMessage(res.data.message || "OTP resent successfully");
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Failed to resend OTP");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2 className="auth-title">Verify OTP</h2>
        <p style={{ textAlign: "center", marginBottom: "20px", fontSize: "14px", color: "#666" }}>
          {otpMethod === "sms" ? "Enter the OTP sent to your phone number" : "Enter the OTP sent to your email address"} <br />
          <strong>{otpMethod === "sms" ? `+91${phone}` : email}</strong>
        </p>
        <form onSubmit={handleVerifyOTP}>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => {
              setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
              setError("");
              setMessage("");
            }}
            maxLength="6"
            required
          />
          {error && <p className="auth-error">{error}</p>}
          {message && <p className="auth-info-message">{message}</p>}
          <button type="submit" className="auth-button" disabled={isVerifying}>
            {isVerifying ? "Verifying..." : "Verify"}
          </button>
        </form>
        <div className="auth-footer">
          <p>
            Didn&apos;t receive the OTP?{" "}
            <span onClick={handleResendOTP}>
              {isResending ? "Resending..." : "Resend OTP"}
            </span>
          </p>
          <p>
            Want to change details?{" "}
            <span onClick={() => navigate(purpose === "login" ? "/login" : "/register")}>
              Go Back
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
